<template>
  <div class="home">
    <app-sidebar></app-sidebar>

    <!-- Shop by category section -->
    <div class="wrapper-content">
      <app-header></app-header>

      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Calender</h2>
        </div>
      </div>

      <div class="addmoney newaddress">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="add-newaddresss panel">
                <div class="row">
                  <div class="col-lg-5 col-md-12 calenderContainer">
                    <datepicker :inline="true"></datepicker>
                  </div>
                  <div class="col-lg-7 col-md-12 calenderList">
                    <div class="dateDefiner">16-jan-2020</div>
                    <div class="orderList">
                      <div class="orderContainer">
                        <div class="productImageOrder">
                          <img class="svg" src="../assets/images/verka.jpg" alt="placeholder" />
                        </div>
                        <div class="orderDetailLeft">
                          <h4>Vita Milk</h4>
                          <p>
                            <b>Quantity-</b> 2
                          </p>
                          <p>
                            <b>TIme-</b> 9:10 AM-3:00 PM
                          </p>
                        </div>
                        <div class="orderDetailRight">
                          <p class="upcomingOrder">
                            <b>Status-</b> UPCOMING
                          </p>
                          <div class="amountPrice">
                            <span>Amount</span>
                            <sup>&#8377;</sup>524
                          </div>
                        </div>
                      </div>
                      <div class="deliveryAddress">
                        <b>
                          <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" /> HOME
                        </b>Abu Dhabi, Muroor Road, Sector-67, UAE
                      </div>
                    </div>
                    <div class="orderList">
                      <div class="orderContainer">
                        <div class="productImageOrder">
                          <img class="svg" src="../assets/images/verka.jpg" alt="placeholder" />
                        </div>
                        <div class="orderDetailLeft">
                          <h4>Vita Milk</h4>
                          <p>
                            <b>Quantity-</b> 2
                          </p>
                          <p>
                            <b>TIme-</b> 9:10 AM-3:00 PM
                          </p>
                        </div>
                        <div class="orderDetailRight">
                          <p class="deliveredOrder">
                            <b>Status-</b> DELIVERED
                          </p>
                          <div class="amountPrice">
                            <span>Amount</span>
                            <sup>&#8377;</sup>524
                          </div>
                        </div>
                      </div>
                      <div class="deliveryAddress">
                        <b>
                          <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" /> HOME
                        </b>Abu Dhabi, Muroor Road, Sector-67, UAE
                      </div>
                    </div>
                    <div class="orderList">
                      <div class="orderContainer">
                        <div class="productImageOrder">
                          <img class="svg" src="../assets/images/verka.jpg" alt="placeholder" />
                        </div>
                        <div class="orderDetailLeft">
                          <h4>Vita Milk</h4>
                          <p>
                            <b>Quantity-</b> 2
                          </p>
                          <p>
                            <b>TIme-</b> 9:10 AM-3:00 PM
                          </p>
                        </div>
                        <div class="orderDetailRight">
                          <p class="upcomingOrder">
                            <b>Status-</b> UPCOMING
                          </p>
                          <div class="amountPrice">
                            <span>Amount</span>
                            <sup>&#8377;</sup>524
                          </div>
                        </div>
                      </div>
                      <div class="deliveryAddress">
                        <b>
                          <img class="svg" src="../assets/images/placeholder.svg" alt="placeholder" /> HOME
                        </b>Abu Dhabi, Muroor Road, Sector-67, UAE
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="parentSidebar" id="parentx">
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Datepicker from "vuejs-datepicker";

export default {
  name: "calender",
  components: {
    "app-header": Header,
    "app-sidebar": Sidebar,
    "app-footer": Footer,
    Datepicker
  }
};
</script>
